// Function loadWoolLabSwatchDetailModalBlock loads the WoolLabSwatchDetailModalBlock class by dynamically importing the js on demand if needed

export function loadWoolLabSwatchDetailModalBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-modal-widget-chunk" */ '../widgets/woolLabSwatchDetailModalBlock').then(wg => {

		const { WoolLabSwatchDetailModalBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabSwatchDetailModalBlock"]');

		if(!$wg) {
			// console.info('WoolLabSwatchDetailModalBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabSwatchDetailModalBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabSwatchDetailModalBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabSwatchDetailModalBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabSwatchDetailModalBlock widget');

}
